// frontend/shared/src/storage.ts —— TD-811
export interface TokenStore {
  get(): string | null;
  set(token: string, persist: boolean): void;
  clear(): void;
  isPersistent(): boolean;
}

export const TOKEN_KEYS = { user: 'gpu_at_user', agent: 'gpu_at_agent', admin: 'gpu_at_admin' } as const;

export function memoryTokenStore(): TokenStore {
  let token: string | null = null;
  let persist = false;
  return {
    get: () => token,
    set: (t, p) => {
      token = t;
      persist = p;
    },
    clear: () => {
      token = null;
      persist = false;
    },
    isPersistent: () => token !== null && persist,
  };
}

function safeStorage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

// persist=true 写 localStorage；persist=false（受限窗口 token）只存内存并清掉旧的持久 token
export function localTokenStore(key: string): TokenStore {
  const mem = memoryTokenStore();
  const ls = safeStorage();
  let saved: string | null = null;
  try {
    saved = ls?.getItem(key) ?? null;
  } catch {
    // 读取被拒（SecurityError 等）时按无持久 token 处理
    saved = null;
  }
  if (saved) mem.set(saved, true);
  return {
    get: () => mem.get(),
    set: (t, p) => {
      mem.set(t, p);
      try {
        if (p) ls?.setItem(key, t);
        else ls?.removeItem(key);
      } catch {
        // 存储不可用（隐私模式）时退化为内存会话
      }
    },
    clear: () => {
      mem.clear();
      try {
        ls?.removeItem(key);
      } catch {
        // 同上
      }
    },
    isPersistent: () => mem.isPersistent(),
  };
}

export function readLocal(key: string): string | null {
  try {
    return safeStorage()?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string | null): void {
  try {
    const ls = safeStorage();
    if (value === null) ls?.removeItem(key);
    else ls?.setItem(key, value);
  } catch {
    // 忽略：仅偏好类键
  }
}
